module.exports = __webpack_public_path__ + "img/u25965.b28d4c53.png";